import { render, staticRenderFns } from "./MySlider.vue?vue&type=template&id=4d046877&scoped=true&"
import script from "./MySlider.vue?vue&type=script&lang=js&"
export * from "./MySlider.vue?vue&type=script&lang=js&"
import style0 from "./MySlider.vue?vue&type=style&index=0&id=4d046877&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d046877",
  null
  
)

export default component.exports